var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--twemoji",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ED2939",
    d: "M36 27a4 4 0 0 1-4 4h-8V5h8a4 4 0 0 1 4 4v18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#002495",
    d: "M4 5a4 4 0 0 0-4 4v18a4 4 0 0 0 4 4h8V5H4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "M12 5h12v26H12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrFlag);
export default __webpack_public_path__ + "static/media/fr_flag.49a83f17683f35094a3776657478bcde.svg";
export { ForwardRef as ReactComponent };